import { HYDRATE } from "next-redux-wrapper";
import { ActionsSearchBrandService } from "./actions";

const initialState = { data: [], status: "fetch_init", message: "" };

function storeSearchBrandService(state = initialState, action) {

	switch (action.type) {

	case HYDRATE:
		return { ...state, ...action.payload.storeSearchBrandService };
	case ActionsSearchBrandService.LOAD_GET_SEARCH_BRANDS_SERVICE:
		return { ...state, data: action.data, status: "fetch_loading" };
	case ActionsSearchBrandService.RES_GET_SEARCH_BRANDS_SERVICE:
		return { ...state, data: action.data, status: "fetch_result" };
	case ActionsSearchBrandService.ERR_GET_SEARCH_BRANDS_SERVICE:
		return {
			...state,
			data: action,
			status: "fetch_error",
			message: "Error...",
		};
	default:
		return { ...state };

	}

}

export default storeSearchBrandService;
